import React, { useState, useEffect, useRef } from 'react'
import { connect } from "react-redux"
import TextField from "@material-ui/core/TextField"
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import { useHistory } from 'react-router-dom'
import Button from "@material-ui/core/Button"
import DataTable from 'react-data-table-component'
import { CollateralStyles } from '../../CollateralStyles'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import Input from '@material-ui/core/Input'
import { Backdrop, CircularProgress, FormHelperText  } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import Modal from 'antd/es/modal';
import FormControl from '@material-ui/core/FormControl';
import UseForm from '../../../common/UseForm'
import { Container } from '@material-ui/core'
import { customStyleSecondary } from '../../../common/CommonStyles'
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

const Comments = ({ classes, ...props }) => {
    const history = useHistory()
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [loading, setLoading] = useState(false);
    const [comment, setComment] = useState();
    const isFirstRender = useRef(true);
    const isFirstRenderTypePlate = useRef(true);
    const [selectedEntidad, setSelectedEntidad] = useState(props.workDetail[0].idStatePlate);
    const [selectedTipoPlaca, setSelectedTipoPlaca] = useState(props.workDetail[0].idTypePlate);
    const [placa, setPlaca] = useState(props.workDetail[0].verifiedPlateNo);
    const [verificaPlaca, setVerificaPlaca] = useState(props.workDetail[0].verifiedPlateNo);
    const [showPlateError, setShowPlateError] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(props.workDetail && props.workDetail[0] ? props.workDetail[0].verifiedPlateInd : true);

    const [errors, setErrors] = useState({
        entidad: false,
        tipoPlaca: false,
        placa: false,
        verificaPlaca: false,
        evidencia: false,
        comentariosEvidencia: false,
        estructuraPlaca: false
    });

const plateMismatch =
    verificaPlaca !== "" &&
    placa !== "" &&
    verificaPlaca !== placa;

    const { t } = useTranslation()
    const paginationOptions = { rowsPerPageText: t('commonMessages.rowsPerPage'), rangeSeparatorText: t('common.to'), selectAllRowsItem: true, selectAllRowsItemText: t('common.all') }

    const initialCommentBody = {
        "FormFile": {},
        "WOID": "",
        "BranchOfficeId": "",
        "StageID": "",
        "Comment": ""
    }

    const {
        values,
        handleInpuFileChange
    } = UseForm(initialCommentBody)

    useEffect(() => {
        handleOpenBackdrop()
        props.actions.fetch_Comments(props.userLanguage, props.userToken, props.match.params.woid, props.match.params.branchOfficeId, onError, onSuccess)
        return () => {
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        handleOpenBackdrop()
        props.actions.fetch_StatePlate(props.userLanguage, props.userToken, onError, onSuccess)
        props.actions.fetch_TypePlate(props.userLanguage, props.userToken, onError, onSuccess)
        props.actions.fetch_WOProcedurePlate(props.userLanguage, props.userToken, props.match.params.woid, onError, onSuccess)
        return () => {}
    }, []) 

    //CUANDO SE MODIFICA EL ESTADO/TIPO DE PLACA SE REINICIA
    useEffect(() => {

        if (isFirstRender.current) {
            isFirstRender.current = false;
            return; 
        }

        setSelectedTipoPlaca(0);
        setPlaca("");
        setVerificaPlaca("");
        const plateValid = validatePlate("");
        setShowPlateError(!plateValid && placa);
    }, [selectedEntidad]);

    useEffect(() => {

        if (isFirstRenderTypePlate.current) {
            isFirstRenderTypePlate.current = false;
            return; 
        }

        setPlaca("");
        setVerificaPlaca("");
        const plateValid = validatePlate("");
        setShowPlateError(!plateValid && placa);
    }, [selectedTipoPlaca]);


    //VALIDA PATRON PLACA
    useEffect(() => {
        const plateValid = validatePlate(placa);
        setShowPlateError(!plateValid && placa);

    }, [placa]);


    //SOLO SE MUESTRA SECCION PLACAS CUANDO APLICA
    const shouldShowPlateSection = props.workDetail?.[0]?.collateralStageID === 3 && props.woprocedurePlate == 1;
    
    //FILTRA TIPO DE PLACA POR EL ESTADO SELECCIONADO
    const filteredTypePlates = selectedEntidad
    ? (
        props.statePlate
            ?.find(s => s.stateId === selectedEntidad)
            ?.pattronPlate || []
      )
        .map(p => p.typePlateId)
        .filter((v, i, self) => self.indexOf(v) === i)
    : [];


    const handleSubmit = e => {
        if(shouldShowPlateSection){
            //VALIDA FORM PLACAS
            const newErrors = {
                entidad: !selectedEntidad,
                tipoPlaca: !selectedTipoPlaca,
                placa: !placa,
                verificaPlaca: !verificaPlaca,
                comentariosEvidencia: !comment,
                evidencia: !values.pdf || values.pdf.length === 0,
                estructuraPlaca: showPlateError
            };

            setErrors(newErrors);
            const hasErrors = Object.values(newErrors).some(v => v);
            if (hasErrors || placa !== verificaPlaca) return;
        }

        e.preventDefault()
        if (comment !== undefined) {            
            setLoading(true); //loading
            const formData = new FormData()
            formData.append('WOID', props.workDetail[0].woid)
            formData.append('BranchOfficeId', props.match.params.branchOfficeId)
            formData.append('StageID', props.workDetail[0].collateralStageID)
            formData.append('Comment', comment)

            if(shouldShowPlateSection){
                formData.append('Plate', placa)
                formData.append('idStatePlate', selectedEntidad)
                formData.append('idTypePlate', selectedTipoPlaca)
            }

            const MAX_FILE_SIZE = 30 * 1024 * 1024;

            if (values.pdf !== undefined && values.pdf.length !== 0) {
                for (let file of values.pdf) {
                    if(file.size > MAX_FILE_SIZE){
                        Modal.error({
                            title: 'Error',
                            content: t('commonMessages.errorMBexceeded')
                        })
                        setLoading(false); //loading
                        return;
                    }

                    formData.append("FormFile", file);
                    props.actions.post_Comments(props.userLanguage, props.userToken, formData, onError, onSuccessSave)
                }
            } else {
                props.actions.post_Comments(props.userLanguage, props.userToken, formData, onError, onSuccessSave)
            }
        } else {
            Modal.error({
                title: 'Error',
                content: t('commonMessages.errorUndefined')
            })
        }
    }

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }
    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }
    const onSuccess = () => {
        handleCloseBackdrop()
    }

    const onSuccessSave = async (response) => {
        setLoading(false);
        if (response.success) {
            Modal.success({
                title: t('commonMessages.savedSucc')
            })
        } else {
            Modal.error({
                title: t('commonMessages.alert500')
            })
        }
        props.actions.fetch_Comments(props.userLanguage, props.userToken, props.match.params.woid, props.match.params.branchOfficeId, onError, onSuccess)
        if(props.screenType){ props.actions.fetch_Work_Order_Detail(props.userLanguage, props.userToken, props.match.params.branchOfficeId, props.match.params.woid, props.screenType, onError, onSuccess) }

        setComment("")
        setIsSubmitting(true);

        Array.from(document.querySelectorAll("input")).forEach(
            input => (input.value = "")
        )
    }

    const onError = (err) => {
        setLoading(false); //loading
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 400:
                    Modal.error({
                        title: 'Error',
                        content: t(`collateralErrors.${err.response.data.errors.ErrorCodes[0]}`)
                    })
                    break
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    alert(t('commonMessages.alert500'))
                    break
                default:
                    break
            }
        }
    }

    const checkFileType = event => {
        let file = event.target.files[0]
        if (file != null) {
            let types = ['application/pdf', 'image/png', 'image/jpeg']

            if (types.every(type => file.type !== type)) {
                Modal.error({
                    title: 'Error',
                    content: t('commonMessages.unsupportedFormat')
                })
                event.target.value = null
                return false
            } else {
                handleInpuFileChange(event)
            }
        }
    }

    const onSuccessDelete = (response) => {
        handleCloseBackdrop()
        props.actions.fetch_Comments(props.userLanguage, props.userToken, props.match.params.woid, props.match.params.branchOfficeId, onError, onSuccess)
        if (response.success) {
            Modal.success({
                title: t('commonMessages.deletedSucc')
            })
        } else {
            Modal.error({
                title: 'Error',
                content: response.message
            })
        }
    }

    const handleDelete = (wocid) => {
        handleOpenBackdrop()
        props.actions.delete_Comment(props.userLanguage, props.userToken, wocid, props.match.params.woid, props.match.params.branchOfficeId, onError, onSuccessDelete)
    }

    const handleDownload = (documentId, woId) => {
        handleOpenBackdrop()
        props.actions.download_document(props.userLanguage, props.userToken, onError, woId, onSuccess)
    }


    const validatePlate = (plate) => {
        if (!plate) return true; 
        if (!selectedEntidad || !selectedTipoPlaca) return true; // SI ESTA VACIO NO VALIDA

        const state = props.statePlate?.find(s => s.stateId === selectedEntidad);
        if (!state) return true;

        const patterns = state.pattronPlate?.filter(
            p => p.typePlateId === selectedTipoPlaca
        );
        if (!patterns || patterns.length === 0) return true;

        // VALIDA PATRONES
        return patterns.some(p => {
            // REGEX
            const regexPattern = "^" + p.patronPlate.replace(/X/g, "[A-Z]").replace(/9/g, "[0-9]") + "$";
            const regex = new RegExp(regexPattern, "i");

            return regex.test(plate);
        });
    };

    const columns = [
        {
            name: t('collateralDetails.comments'),
            selector: 'comment',
            width: '682px',
            sortable: true,
            cell: row => row.comment
        },
        {
            name: t('collateralDetails.registerDate'),
            selector: 'creationDate',
            width: '175px',
            sortable: true,
            cell: row => row.creationDate
        },
        {
            name: t('common.user'),
            selector: 'creationUser',
            width: '171px',
            sortable: true,
            cell: row => row.creationUser
        },
        {
            name: t('collateralDetails.nameFilecomments'),
            selector: 'documentFilename',
            width: '150px',
            sortable: true,
            cell: row => row.documentFilename
        },
        {
            name: "",
            center: true,
            width: '150px',
            cell: row => (buttonForColumns(row))
        }
    ]

    const buttonForColumns = (row) => {
        return (
            <div>
                <Tooltip title={t('common.delete')}>
                    <IconButton style={{ color: '#BF2E2E' }} onClick={() => handleDelete(row.wocid)}>
                        <DeleteForeverIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title={t('common.download')}>
                    <IconButton style={{ color: '#7D7D7D' }} onClick={() => handleDownload(row.documentID, row.wocid)}>
                        <CloudDownloadIcon />
                    </IconButton>
                </Tooltip>
            </div>
        )
    }

    return (
        <div>
            <Backdrop className={classes.backdrop} open={loading}><CircularProgress color="inherit" /></Backdrop>
            <Container className={classes.generalBorder}>
                <Backdrop className={classes.backdrop} open={openBackdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <br />
                <Grid
                    container
                    direction="row"
                    justify="space-around"
                    alignItems="center"
                    spacing={2}
                >
                    <Grid item xs={12}>
                        <Typography variant="body1" component={'span'}>
                            <Box fontWeight={600}>{t('collateralDetails.uploadComment')}</Box>
                        </Typography>
                        <Typography variant="body1">
                            {t('common.comment')}
                        </Typography>
                        <FormControl fullWidth error={errors.comentariosEvidencia}>
                        <TextField
                            label=""
                            value={comment}
                            variant="outlined"
                            onChange={e => setComment(e.target.value)}
                            fullWidth={true}
                            multiline
                            rows={3}
                        />
                        {errors.comentariosEvidencia && <FormHelperText>Dato Obligatorio</FormHelperText>}
                        </FormControl>
                    </Grid>
                    <Grid container item xs={12} spacing={2}>
                        <Grid item xs={4}>
                            <Typography>{shouldShowPlateSection ? t('commonMessages.addEvidence') : t('commonMessages.addFile')}</Typography>
                            <FormControl fullWidth error={errors.evidencia}>
                            <Input
                                fullWidth
                                type="file"
                                name="pdf"
                                className="filePDF"
                                onChange={checkFileType}
                            />
                            {errors.evidencia && <FormHelperText>Dato Obligatorio</FormHelperText>}
                            </FormControl>
                        </Grid>

                        {shouldShowPlateSection && (
                        <Grid item xs={6}>
                            <Grid container spacing={2}>
                                <Grid item xs={3}>
                                    <Typography>{t('collateralDetails.stateEntity')}</Typography>
                                    <FormControl fullWidth error={errors.entidad}>
                                        <Select
                                            value={selectedEntidad}
                                            onChange={(e) => setSelectedEntidad(e.target.value)}
                                            disabled={isSubmitting}>
                                            {props.statePlate && props.statePlate.map((item) => (
                                                <MenuItem key={item.stateId} value={item.stateId}>
                                                    {item.stateName}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {errors.entidad && <FormHelperText>Dato Obligatorio</FormHelperText>}
                                    </FormControl>
                                </Grid>

                                <Grid item xs={3}>
                                    <Typography>{t('collateralDetails.typePlate')}</Typography>
                                    <FormControl fullWidth error={errors.tipoPlaca}>
                                        <Select
                                            labelId="tipo-placa-label"
                                            value={selectedTipoPlaca}
                                            onChange={(e) => setSelectedTipoPlaca(e.target.value)}
                                            disabled={isSubmitting}>
                                            {filteredTypePlates.length > 0 ? (
                                                filteredTypePlates.map(typeId => {
                                                    // buscamos el nombre del tipo de placa en props.typePlate
                                                    const type = props.typePlate.find(t => t.statusId === typeId);
                                                    if (!type) return null;
                                                    return (
                                                        <MenuItem key={type.statusId} value={type.statusId}>
                                                            {type.status}
                                                        </MenuItem>
                                                    );
                                                })
                                            ) : (
                                                <MenuItem value="" disabled>
                                                    Selecciona primero una Entidad
                                                </MenuItem>
                                            )}
                                        </Select>
                                        {errors.tipoPlaca && <FormHelperText>Dato Obligatorio</FormHelperText>}
                                    </FormControl>
                                </Grid>

                                <Grid item xs={3}>
                                    <Typography>{t('collateralDetails.Plate')}</Typography>
                                    <FormControl fullWidth error={errors.placa}>
                                    <Input
                                        labelId="placa-label"
                                        value={placa}
                                        onChange={(e) => setPlaca(e.target.value.toUpperCase())}
                                        disabled={isSubmitting}/>
                                    {errors.placa && <FormHelperText>Dato Obligatorio</FormHelperText>}
                                    {showPlateError && (<FormHelperText style={{ color: "red" }}>El campo placa no cumple con la estructura</FormHelperText>)}
                                    </FormControl>
                                </Grid>

                                <Grid item xs={3}>
                                    <Typography>{t('collateralDetails.VerifiedPlate')}</Typography>
                                    <FormControl fullWidth error={errors.verificaPlaca || plateMismatch}>
                                    <Input
                                        labelId="verifica-placa-label"
                                        value={verificaPlaca}
                                        onChange={(e) => setVerificaPlaca(e.target.value.toUpperCase())}
                                        onPaste={(e) => e.preventDefault()}
                                        disabled={isSubmitting}/>
                                    {errors.verificaPlaca && <FormHelperText>Dato Obligatorio</FormHelperText>}
                                    {plateMismatch && (
                                        <FormHelperText style={{ color: "red" }}>
                                            No coincide con el campo Placa
                                        </FormHelperText>
                                    )}
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Grid>
                        )}

                        <Grid item xs={2} style={{ textAlign: 'right' }}>
                            <br />
                            <Button
                            type="button"
                            className={classes.generalBorder}
                            variant="outlined"
                            onClick={handleSubmit}
                            >
                            {t('common.send')}
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}></Grid>
                </Grid>
                <Grid>
                    <br />
                    <Typography variant="body1" component={'span'}>
                        <Box fontWeight={600}>{t('collateralDetails.commentsHistory')}</Box>
                    </Typography>
                    <DataTable
                        columns={columns}
                        customStyles={customStyleSecondary}
                        data={props.comments}
                        highlightOnHover
                        defaultSortField="registerDate"
                        dense
                        noHeader
                        responsive
                        striped
                        pointerOnHover
                        pagination
                        paginationComponentOptions={paginationOptions}
                        noDataComponent={<p className={classes.marginNoData}>{t('commonMessages.noData')}</p>}
                    />
                </Grid>
                <br />
            </Container>
        </div>
    )
}

const mapStateToProps = state => ({
    userProfile: state.UserProfileReducer.list,
    comments: state.CollateralReducer.comments,
    statePlate: state.CollateralReducer.statePlate,
    typePlate: state.CollateralReducer.typePlate,
    woprocedurePlate: state.CollateralReducer.woprocedurePlate,
    listByStatus: state.CollateralReducer.listOrders,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

export default connect(mapStateToProps)(withStyles(CollateralStyles)(Comments))